// extracted by mini-css-extract-plugin
module.exports = {"homeCategory":"HomeCategory_homeCategory__dqYca","homeCategoryIcon":"HomeCategory_homeCategoryIcon__EXRLR"};